import { render, staticRenderFns } from "./MessageDetails.vue?vue&type=template&id=7bdbfd8a&scoped=true"
import script from "./MessageDetails.vue?vue&type=script&lang=js"
export * from "./MessageDetails.vue?vue&type=script&lang=js"
import style0 from "./MessageDetails.vue?vue&type=style&index=0&id=7bdbfd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdbfd8a",
  null
  
)

export default component.exports